import { create } from 'zustand';

/** Who is using the app. Local-only today; a Supabase adapter can replace `bootstrap()` later. */
export type Identity =
  | { status: 'anonymous' }
  | { status: 'signed-in'; id: string; email?: string; roles: readonly string[] };

interface IdentityState {
  identity: Identity;
  set: (identity: Identity) => void;
}

export const useIdentity = create<IdentityState>((set) => ({
  identity: { status: 'anonymous' },
  set: (identity) => set({ identity }),
}));

export const isAdmin = (i: Identity): boolean => i.status === 'signed-in' && i.roles.includes('admin');
